module.exports = __webpack_public_path__ + "img/edit-white.a927ce3b.svg";